module.exports = __webpack_public_path__ + "static/media/Cap-Team2.d72f1c90.png";